import { createSelector } from 'reselect'
import { selectCurrentConversation } from 'ducks/tickets/selectors/selectCurrentConversation'

export const selectCurrentTicketTitle = createSelector(
  selectCurrentConversation,
  ticket => ticket && ticket.subject
)
